import type {PermissionType} from '@hconnect/apiclient'

import {HrocJtbdRole} from '../enums'

const getEnumKeyByValue = (value: string) => {
  return Object.keys(HrocJtbdRole)[Object.values(HrocJtbdRole).indexOf(value as HrocJtbdRole)]
}

const permissionToRoleMap = new Map<string, HrocJtbdRole>([
  ['EDIT_MAJOR_OUTAGE_LEAD_JTBD', getEnumKeyByValue('Major Outage Lead') as HrocJtbdRole],
  [
    'EDIT_OPTIMIZATION_SPECIALIST_JTBD',
    getEnumKeyByValue('Optimization Specialist') as HrocJtbdRole
  ],
  ['EDIT_PROCESS_ENGINEER_JTBD', getEnumKeyByValue('Process Engineer') as HrocJtbdRole],
  ['EDIT_QUALITY_ENGINEER_JTBD', getEnumKeyByValue('Quality Engineer') as HrocJtbdRole],
  ['EDIT_RELIABILITY_ENGINEER_JTBD', getEnumKeyByValue('Reliability Engineer') as HrocJtbdRole],
  ['EDIT_SYSTEM_ENGINEER_JTBD', getEnumKeyByValue('System Engineer') as HrocJtbdRole],
  ['EDIT_REGIONAL_MANAGER_JTBD', getEnumKeyByValue('System Engineer') as HrocJtbdRole]
])

const permissionTypeToRoleMap = new Map<PermissionType, HrocJtbdRole>([
  ['EDIT_MAJOR_OUTAGE_LEAD_JTBD', getEnumKeyByValue('Major Outage Lead') as HrocJtbdRole],
  [
    'EDIT_OPTIMIZATION_SPECIALIST_JTBD',
    getEnumKeyByValue('Optimization Specialist') as HrocJtbdRole
  ],
  ['EDIT_PROCESS_ENGINEER_JTBD', getEnumKeyByValue('Process Engineer') as HrocJtbdRole],
  ['EDIT_QUALITY_ENGINEER_JTBD', getEnumKeyByValue('Quality Engineer') as HrocJtbdRole],
  ['EDIT_RELIABILITY_ENGINEER_JTBD', getEnumKeyByValue('Reliability Engineer') as HrocJtbdRole],
  ['EDIT_SYSTEM_ENGINEER_JTBD', getEnumKeyByValue('System Engineer') as HrocJtbdRole],
  ['EDIT_REGIONAL_MANAGER_JTBD', getEnumKeyByValue('System Engineer') as HrocJtbdRole]
])

export const useJobsToBeDoneDefaultRole = (permission: string) => {
  if (permission === undefined) {
    return ''
  }

  return permissionToRoleMap.get(permission as HrocJtbdRole) as HrocJtbdRole
}

export const getPermissionByRole = (role: string) => {
  const roleEnumValue = role as HrocJtbdRole

  for (const [permission, mappedRole] of permissionToRoleMap.entries()) {
    if (mappedRole === roleEnumValue) {
      return permission
    }
  }
  return undefined
}

export const getPermissionTypeByRole = (role: PermissionType) => {
  const roleEnumValue = role as HrocJtbdRole

  for (const [permission, mappedRole] of permissionTypeToRoleMap.entries()) {
    if (mappedRole === roleEnumValue) {
      return permission
    }
  }
  return undefined
}
